<template>
  <div class="c-tabs-content">
    <Spin size="large" fix v-if="!loading" />
    <selecter
      v-model="categories"
      :data="data"
      :title="title"
      :transfer="false"
      :disabled="disabled"
      search
      clear
      resource-title
      @on-checked="handleCheck"
      @on-title="selectTif"
      @on-select="selectAll"
    />
    <div class="correlation-word" v-if="action">
      <template v-if="recommoned">
        <dd>
          <a href="javascript:;" class="g-pull-right" @click.stop="$emit('on-more')"> 更多<Icon type="ios-arrow-forward" /> </a>
          {{ queryWord }}相关词：
        </dd>
        <dd>
          <Tooltip
            v-for="key in recommons"
            :key="key.id"
            :content="`${key.name}覆盖人数：${key.num}`"
            theme="light"
            placement="top"
            transfer
          >
            <a href="javascript:;" v-if="check(key.id)" class="c-recommon-a c-checked-span">+{{ key.name }}</a>
            <a href="javascript:;" v-else class="c-recommon-a" :class="{ 'c-checked-span': disabled }" @click="selectKeyword(key)"
              >+{{ key.name }}</a
            >
          </Tooltip>
        </dd>
      </template>
      <template v-else>
        <dd>关键词推荐：</dd>
        <dd><span>选择类目词后, 根据相关性推荐关键词</span></dd>
      </template>
    </div>
    <div class="correlation-word" v-else>
      <dd>关键词推荐：</dd>
      <dd><span>兴趣暂不支持关键词推荐</span></dd>
    </div>
  </div>
</template>
<script>
import { isArray, getNameOfData, getKeyOfData } from '@/common/js/utils'
import Selecter from '@/components/select/selecter.vue'
export default {
  name: 'Category',
  components: { Selecter },
  props: {
    value: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    data: {
      type: Array
    },
    recommons: {
      type: Array
    },
    queryWord: {
      type: String,
      default: ''
    },
    words: {
      type: Array,
      required: true
    },
    completeData: {
      type: Array
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    action: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    categories: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    recommoned() {
      return isArray(this.recommons) && this.recommons.length
    },
    title() {
      const title = '行为类目词'
      let sub = []
      if (isArray(this.resCurrents)) {
        sub = this.resCurrents.map((ret) => {
          const { value } = getKeyOfData(this.data, 'key', ret)
          return value || ''
        })
      }
      return [title, ...sub]
    },
    check() {
      return (id) => this.words.map((ret) => ret.id).includes(id)
    }
  },
  methods: {
    selectHandle(val) {
      const { name, id } = val
      this.selectAll({ list: this.data, check: true, current: name, id })
    },
    changeHandle(val) {
      if (val === '') this.$emit('on-cancel', 'gategory')
    },
    searcHandle(query) {
      this.$emit('on-complete', query)
    },
    handleCheck(val) {
      if (!this.action) return
      const { key, name, check } = val
      if (check && key) {
        this.$emit('on-search', {
          id: key,
          name,
          tag_type: 'CATEGORY'
        })
      } else this.$emit('on-clear')
    },
    // 选中子集Title
    selectTif(val) {
      this.resCurrents = val
    },
    // 添加相关推荐词
    selectKeyword(word) {
      if (this.disabled) return
      this.$emit('on-select', [word])
    },
    // 全选
    selectAll({ list, check = true, current = '', id }) {
      const setCheck = (meta, val) => {
        if (meta.children && meta.children.length) {
          meta.children.forEach((ret) => {
            setCheck(ret, val)
          })
        }
        this.$set(meta, 'check', val)
        this.$set(meta, '_time', Date.now()) // 用于排序
      }
      // 优先id
      if (id) {
        const item = getKeyOfData(list, 'key', id)
        setCheck(item, check)
      } else if (current) {
        const item = getNameOfData(list, current)
        setCheck(item, check)
      } else {
        // 根层全选
        list.forEach((ret) => {
          setCheck(ret, check)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tabs-content {
  z-index: 1024;

  .ivu-spin-fix {
    z-index: 998;
  }
}

.correlation-word {
  padding-top: 10px;
  line-height: 20px;
  font-weight: 400;

  .c-recommon-a {
    padding-right: 8px;
  }

  .c-checked-span {
    color: #a8d7ff;
    cursor: default;
  }

  dd {
    height: 20px;
    margin: 0;
    overflow: hidden;
  }

  span {
    color: #999;
  }
}

.search-suggest-wrap {
  background-color: #ffffff;

  ul {
    overflow: auto;
    max-height: 240px;

    li {
      padding: 0 12px 0;
      margin-bottom: 6px;
      display: flex;
      flex-flow: column;

      &:hover {
        background-color: #f3f3f3;
      }

      span:nth-child(1) {
        font-size: 14px;
        line-height: 22px;
      }

      span:nth-child(2) {
        font-size: 12px;
        line-height: 20px;
        color: #999;
      }
    }
  }
}
</style>
